/** Production default; staging and local hosts are derived at runtime. */
export const DEFAULT_GUARD_WEB_SIGN_IN_URL = "https://guard.thesecops.app/";

/** Resolve the Guard Web sign-in URL for the current console host. */
export function resolveGuardWebSignInUrl(hostname?: string): string {
  const host =
    hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  if (host === "beta.console.thesecops.app") {
    return "https://beta.guard.thesecops.app/";
  }
  if (host.startsWith("staging.") && host.includes("secops-console")) {
    return "https://staging.secops-guard.pages.dev/";
  }
  return DEFAULT_GUARD_WEB_SIGN_IN_URL;
}
